import React,{useEffect,useState} from 'react'
import { Link } from 'react-router-dom';
import classes from '../styles/Product.module.scss'
import {toggle} from '../redux/features/sidebarSlice'
import {addItem,selectCart} from '../redux/features/cartSlice'
import { useDispatch,useSelector } from 'react-redux'
import axios from 'axios'
import { selectUser } from '../redux/features/authSlice'
import { Navigate, useNavigate } from 'react-router-dom'
import {DisplayModal,selectisModalDisplayed,setModalTitle,setModalBody,selectModalBody,setActionPayload,setActionType} from '../redux/features/modalSlice'

const Product = (props) => {
    const {_id,name,slug,images,price,brand,countInStock,description,colors,discount}=props.product;
    const [show,setShow]=useState(false)
    const dispatch=useDispatch()
    ////console.log(images)
    const [isAdmin,setIsAdmin]=useState(false)
    const user = useSelector(selectUser)
    const navigate=useNavigate()
    let isModalDisplayed=useSelector(selectisModalDisplayed)
    const [main,setMain]=useState("")


    // This function is used to delete a product
    const remove =async (id)=>{
        
        dispatch(setModalBody("Are you sure ?"))
        dispatch(setModalTitle("Delete Product"))
        dispatch(setActionType("DELETE_PRODUCT"))
        dispatch(setActionPayload({
            id:id,
            token:user.token
        }))
        
        dispatch(DisplayModal())

        try{
           
            // Send the id of the product we removed to the products component
            props.sendDataToParent(id)
           
        }catch(e){
            ////console.log(e.message)
        }
    }

    // Open confirmation Modal on delete
    const openConfirmationModal= ()=>{
        dispatch(setModalTitle("Remove Product Confirmation"))
        dispatch(setModalBody("Are you sure you want to delete this product ?"))
        dispatch(DisplayModal())
    }

    const showProduct=(url)=>{
        navigate(url)
    }

    useEffect(()=>{
        // check if the logged in user is user or admin
        if (user!=null){
            //console.log("this is the role :"+user.user.role)
            if (user.user.role === "admin"){
                setIsAdmin(true)
            }else{
                setIsAdmin(false)
            }
        }
        
        images[0].pictures.map((pic,index)=>{
            //console.log("index:"+index)
            //console.log("obj.mainPicture:"+images[0].mainPicture)
            const initialIndex = pic.substring(pic.lastIndexOf("/") + 1,pic.lastIndexOf("_order"))
            //console.log("initialIndex:"+initialIndex)
            if (Number(initialIndex) === Number(images[0].mainPicture)){
                setMain(pic)
                //console.log(pic)
            }
        })

    },[images])

    const setMainPicture=(obj)=>{
        //console.log("the item itself:"+JSON.stringify(obj))
        //console.log("this is supposed to be an array:"+obj.pictures)
        //const arr = obj.pictures.split(",");
        //console.log("what is it ?"+Array.isArray(obj.pictures)) 

        const picsToStr = obj.pictures.join(",");
        let pics = picsToStr.split(",").map(url => url.trim());

        pics.map((pic,index)=>{
            //console.log("index:"+index)
            //console.log("obj.mainPicture:"+obj.mainPicture)
            const initialIndex = pic.substring(pic.lastIndexOf("/") + 1,pic.lastIndexOf("_order"))
            //console.log("initialIndex:"+initialIndex)
            if (Number(initialIndex) === Number(obj.mainPicture)){
                setMain(pic)
                //console.log(pic)
            }
        })
        
       
    }

    return (
        
        <article data-test="product" className={classes.product} onMouseEnter={()=>setShow(true)} onMouseLeave={()=>setShow(false)}>
            <Link to={`/product/${slug}`} style={{ textDecoration: 'none',color:'black' }}>
                <div className={classes.product_img_wrapper}>
                    <img src={main ? main : images[0].pictures[images[0].mainPicture]} className={classes.img} alt={main} />
                    {countInStock == 0 && <div className={classes.soldout}>Sold OUT</div>}
                </div>
            </Link>
            <div className={classes.colors_wrapper}>
                {images.map((item,i)=>{
                    return <div className={classes.color} key={i} style={{backgroundColor:item.color}} 
                    onClick={()=>setMainPicture(item)}></div>
                })}
            </div>
            <h1 className={classes.title} data-test="product_name">{name}</h1>
            <div className={classes.description} data-test="product_description">{description}</div>
            <div className={classes.description} data-test="product_description">{colors.length+" Colours"}</div>
            {/* <div className={classes.price} data-test="product_price">TND {Number(price).toFixed(2)}</div> */}
            <div className={classes.price} data-test="product_price">{discount && discount > 0 ? (
                <>
                    <span style={{ textDecoration: "line-through", marginRight: "8px" }}>
                    {`TND ${Number(price).toFixed(2)}`}
                    </span>

                    <span>
                    {`TND ${discount.toFixed(2)}`}
                    </span>
                </>
                ) : (
                `TND ${Number(price).toFixed(2)}`
                )}</div>
            {/* if the user is user then show the button to add the product to cart */}
            {/* { !isAdmin && <button onClick={()=> dispatch(addItem(props.product))} className={show ? `${classes.btn} ${classes.btn_show}`:classes.btn}>ADD TO CART</button>} */}
            { !isAdmin && <button onClick={()=> showProduct(`/product/${slug}`)} data-test="add-to-cart" className={show ? `${classes.btn} ${classes.btn_show}`:classes.btn}>View product</button>}
            {/* If the user is admin then show buttons on product for Update and Delete */}
            {/* { isAdmin && <button onClick={()=> remove(_id)} className={classes.deleteBtn}>Delete</button>} */}
            { isAdmin && <button onClick={()=> remove(_id) } className={classes.deleteBtn}>Delete</button>}
            { isAdmin && <Link to={"/admin/product/update/"+_id}><button className={classes.updateBtn}>Update</button></Link>}
        </article>

    )
}

export default Product
